import React, { useState, useRef } from "react";
import About from "../assests/qac24.jpeg";
import emailjs from "@emailjs/browser";
import img82 from "../assests/qac24.jpeg";

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_kb3r1ir", "template_cim9uuc", form.current, {
        publicKey: "dPYa_97xXrg5tnp9Y",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert(
            "Your Message was sent. we will be in contact with you shortly"
          );
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert(
            "Message NOT sent. Please email us on admin@qhubekaac.co.za for further assistance"
          );
        }
      );
  };

  const [contactUs, setContactUs] = useState({
    name: "",
    email: "",
    message: "",
  });

  const onChangehandler = (event) => {
    setContactUs(() => ({
      ...contactUs,
      [event.target.name]: event.target.value,
    }));
    console.log(contactUs);
  };

  return (
    <div name="ContactUs">
      <div
        className="md:pt-72 contain w-full pt-40  bg-bottom justify-center items-center"
        style={{ backgroundImage: `url(${About})` }}
      >
        <form
          ref={form}
          onSubmit={sendEmail}
          action=""
          className="flex  flex-col  w-full  md:py-0 pt-32 px-2 md:px-16"
        >
          <div className="">
            <p className="text-4xl font-bold inline border-b-4 border-blue-500 text-white">
              Contact Us
            </p>
          </div>
          <div className="grid grid-cols-1 ">
            <input
              className="bg-white p-2  opacity-80 hover:opacity-100"
              type="text"
              placeholder="Name"
              name="from_name"
              onChange={onChangehandler}
              required
            />
            <input
              className="my-4 p-2 opacity-80 hover:opacity-100"
              type="email"
              placeholder="email"
              name="from_email"
              onChange={onChangehandler}
              required
            />
            <textarea
              className="opacity-80  p-2 hover:opacity-100"
              name="message"
              rows="10"
              placeholder="message"
              onChange={onChangehandler}
              required
            ></textarea>
            <button
              className=" border-2 bg-white text-blue-700 hover:bg-blue-700 font-bold hover:text-white rounded-md hover:border-blue-600  px-4 py-5 my-8 mx-auto flex items-center "
              onSubmit={sendEmail}
            >
              Send Email
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
